import { type AppAbility, hasBroadPermission } from '@/lib/casl'

/** Broad order editors manage every section; others need that section's field permission. */
export function canManageSalesOrderField(ability: AppAbility, field: string): boolean {
  return (
    hasBroadPermission(ability, 'edit', 'sales-orders') ||
    ability.can('edit', 'sales-orders', field)
  )
}

/** Changing an order's items needs broad order editing or the item-specific permission. */
export function canChangeSalesOrderItems(ability: AppAbility): boolean {
  return (
    hasBroadPermission(ability, 'edit', 'sales-orders') || ability.can('edit', 'sales-order-items')
  )
}
